<section style="max-height:{show?5000:0}px;" id="section-play">
  <div on:click={close} class="title"></div>

  <div class="container">
    <h1>We believe that hard work<br />requires equal play</h1>

    {#each activities as act}
    <article>
      <div>
        <h2>{act.title}</h2>
        <p>{act.desc}</p>
      </div>
      <div>
        <video playsinline muted loop autoplay>
          <source src="/res/play/{act.video}.webm" type="video/webm">
          <source src="/res/play/{act.video}.mov" type="video/mp4">
        </video>
      </div>
    </article>
    {/each}

    <div class="more">
      <h1>There’s more:</h1>
      <div class="list">
        <div>
          <h2>We want you to grow.</h2>
          <p>Mentoring, all sorts of trainings and professional development support – it’s all there and easily accessible.</p>
        </div>
        <div>
          <h2>We want you to feel cared for.</h2>
          <p>Work from home? Always negotiable. Flexible working hours? Whenever possible – sure. Extra vacation days because an emergency has come up? Absolutely.</p>
        </div>
      </div>
    </div>

    <Vacancies />

    <!--ContactUs /-->
  </div>
</section>

<style type="text/scss">
@import '../sass/breakpoints';

section{
  & > .title{
    height:50vh;
    background-image:url('/res/title-play.svg');
    background-size:contain;
    background-repeat:no-repeat;
    background-position:50% 50%;
    min-height:50vh;
    cursor:pointer;
  }
  @media #{$mobile-portrait}{
    & > .title{
      height:130px;
      min-height:130px;
      margin-bottom:50px;      
    }
  }
  @media (max-aspect-ratio: 16/6) {
    & > .intro{
      width:110%;
      margin-left:-5%;
    }
  }
}

section{
  margin:0px auto;
  margin-bottom:100px;
  overflow:hidden;
  /*transition:max-height 0.6s ease-in-out;*/

  .container{
    max-width:980px;
    margin:0px auto;
  }

  h1{ font-size: 60px; letter-spacing: -0.379747px; color: var(--titles); line-height:70px; padding-top:60px; margin-bottom:60px; }
  h2{ font-size: 40px; letter-spacing: -0.379747px; color: #fff; line-height:70px; text-align:left; }
  p{ color:#9acaeb; font-size:16px; line-height:22px; }

  article{
    display:flex;
    flex-direction:row-reverse;
    margin-bottom:50px;
    div{ width:50%; display:flex; flex-direction:column; justify-content:center; padding:0px 20px; }
    video{ width:100%; height:200px; }
    p{ text-align:left; }    
  }
  article:nth-child(odd){
    flex-direction:row;
  }

  .more{
    text-align:center;
    margin-bottom:100px;
    h1{ margin-bottom:20px; }

    .list{
      display:flex;
      flex-direction:row;
      justify-content:space-between;      
      & > div{
        background-color: #2079af;
        text-align:left;        
        padding:46px;        
        width:50%;
        h2{ line-height:100%; padding-bottom:10px; width:80%; }
        p{ color: #9acaeb; font-size: 24px; line-height: 31px; margin-bottom:0px; }

        &:first-child{
          margin-right:25px;
        }
      }
    }    
  } 
}
@media #{$mobile-landscape}{
  section{
    margin-top:20px;
    h1{ font-size:40px; line-height:40px; padding-top:30px; }
    h2{ line-height:40px; }
    .container{
      width:90%;
    }
    article{
      margin:0px;
      video{
        width:100%;
        height:auto;
      }
    }
    .more{
      h1{ margin-top:40px; }
      h2{ margin-top:10px; }
      p{ font-size:1em; }
    }
  }
  article{
    margin-bottom:0px;
    h2{
      margin-top:20px;
      margin-bottom:5px;
    }
  }
  .more{
    margin:20px;
    h2{
      margin-bottom:20px;
    }
  }
}
@media #{$mobile-portrait}{
  section{
    video{
      width:100%;
      height:auto;
    }
    article{
      flex-direction:column;
      &:nth-child(odd){ flex-direction:column; }
      div{
        width:87%;
      }
    }
    .more{
      margin:0px;
      .list{
        flex-direction:column;
        & > div > h2{
          margin-top:10px;
          margin-bottom:15px;
          margin-right:0px;
          margin-left:0px;
          width:100%;
        }
        & > div{
          width:auto;
          padding-left:40px;
          margin:20px;
        }
      }
    }
  }
}
</style>

<script>
import { activities } from '../stores/activities'

import Vacancies from './Vacancies.svelte'
//import ContactUs from './ContactUs.svelte'

export let show

import { section } from '../stores/navigation'
const close = () => {
  section.set('')
}
</script>